export default () => ({
  team: 'Codekillers',
  company: '',
  // Cliente crédito que consulta ventas ({ ruc, name, company }); null para el cliente.
  salesClient: null,
  userData: JSON.parse(localStorage.getItem('x-user')) || {},
  analistData: {},
  charge: {},
  billing: {
    accountState: {
      lastPage: 1,
      lastUpdate: '',
      data: {},
      fileUrl: '',
      fileUrlExcel: ''
    },
    billingReport: {
      lastPage: 1,
      lastUpdate: '',
      data: {},
      fileUrl: '',
    }
  },

  scoring: {
    search: {
      isLoading: false,
      searched: false,
      ruc: "",
    },
    behavior: {
      isOpen: false,
      selected: null,
      data: {},
      current: {}
    },
    score: null,
  },
});
